import { Route } from '@angular/router';
import { BruttoNettoCalculatorComponent } from './components/calculator/brutto-netto-calculator.component';

export const bruttoNettoCalculatorRoutes: Route[] = [
  {
    path: 'brutto-netto-rechner',
    component: BruttoNettoCalculatorComponent
  }
];
